import { render, staticRenderFns } from "./OrderPaymentHistory.vue?vue&type=template&id=8705d858&scoped=true"
import script from "./OrderPaymentHistory.vue?vue&type=script&lang=js"
export * from "./OrderPaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderPaymentHistory.vue?vue&type=style&index=0&id=8705d858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8705d858",
  null
  
)

export default component.exports